import { DriverMetricType } from '@fleet-beat/api';
import { BaseEntityDto, UserDto } from '@fleet-beat/core';

export interface DriverMetricDto extends BaseEntityDto {
  day?: string;
  type?: DriverMetricType;
  driverId?: string;
  driver?: UserDto;
  tenantId?: string;
  total?: number;
  average?: number;
  counter?: number;
}
